import { HiddenElementsScope } from '../hiddenElementsScope';

import {
  unhideComponent,
  previewComponentOnStage,
  stopPreviewComponentOnStage,
} from './unhideComponent';
import { refreshHiddenElements } from './refreshHiddenElements';
import type { HiddenElement } from '../hiddenElementsTypes';

export interface HiddenElementsPrivateApi {
  refreshHiddenElements: () => Promise<void>;
  unhideComponent: (element: HiddenElement) => Promise<void>;
  previewComponentOnStage: (element: HiddenElement) => Promise<void>;
  stopPreviewComponentOnStage: (element: HiddenElement) => void;
}

export const createHiddenElementsPrivateApi = (
  scope: HiddenElementsScope,
): HiddenElementsPrivateApi => {
  const bindScope =
    <T extends any[], K>(fn: (scope: HiddenElementsScope, ...args: T) => K) =>
    (...args: T): K =>
      fn(scope, ...args);

  return {
    refreshHiddenElements: bindScope(refreshHiddenElements),
    unhideComponent: bindScope(unhideComponent),
    previewComponentOnStage: bindScope(previewComponentOnStage),
    stopPreviewComponentOnStage: bindScope(stopPreviewComponentOnStage),
  };
};
